import * as UnifyHeight from './UnifyHeight';
import * as DOMHelpers from './DOMHelpers';

export function applyTo(selector) {
    initialize(selector);
}

function initialize(selector) {
    initializeButton(selector);
}

function initializeButton(selector) {
    document.addEventListener('click', function(event) {
        console.log('asd');
        let target = event.target || event.srcElement;

        while(target !== null && target.matches('[data-endless-list-block="next"] button') === false) {
            target = target.parentElement;
        }

        if(target) {
            console.log('444');
            event.preventDefault();
            console.log(target.hasOwnProperty('endlessListParent'));
            if(target.hasOwnProperty('endlessListParent') === false) {
                target.endlessListParent = DOMHelpers.findParentBySelector(target, selector);
            }
            console.log('test');
            let nextPageLink = target.endlessListParent.querySelector('.next-page-link').getAttribute('href');
            loadOthers(nextPageLink, target.endlessListParent);
        }
    });
}

function loadOthers(nextLink, element) {
    fetch(nextLink).then(response => {
        return response.text();
    }).then(response => {
        return new DOMParser().parseFromString(response, 'text/html')
    }).then(response => {
        let blockKey = element.dataset.endlessList;
        let blocks = response.querySelectorAll('[data-endless-list=' + blockKey + '] [data-endless-list-block]');

        blocks.forEach(function(block) {
            let blockName = block.getAttribute('data-endless-list-block');
            let blockSelector = '[data-endless-list-block="'+blockName+'"]';
            let originalBlock = element.querySelector(blockSelector);
            if(blockName === 'items-list') {
                originalBlock.innerHTML = originalBlock.innerHTML+block.innerHTML;
            } else {
                originalBlock.innerHTML = block.innerHTML;
            }
        });

        UnifyHeight.applyTo('.js-unify-height');
        UnifyHeight.applyDataAttribute();
    });
}
